<template>
    <b-modal
      title="Editar Produto"
      no-close-on-backdrop
      size="xl"
      ok-only
      centered
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
      :busy="loading"
      ok-title="Fechar"
      ok-variant="danger"
    >
  
    <b-row class="container">
      <b-col cols="12" class="mb-4 imgWidth">
          <img
            :src="
              linkFotos(product.origem) +
              product.photo
            "
            :alt="product.product"
            class="imgWidth"
          />
        </b-col>

      <b-col cols="12" class="mb-3 text-center">
        <span class="title"> {{ product.product }} </span>
      </b-col>

      <b-col cols="12" class="mb-1 text-center">
        <span><strong>Marca:</strong> {{ product.marca }} </span>
      </b-col>

      <b-col cols="12" class="mb-1 text-center">
        <span><strong>Código de Barras:</strong> {{ product.codbar }} </span>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" md="6">
        <label>Preço</label>
        <InputMoney
          class="mt-1"
          v-model="fields.priceSalesFormat1"
        />
      </b-col>

      <b-col cols="12" md="6" class="mt-3">
        <label>Estoque</label>
        <b-input
          v-mask="['##########']"
          v-model="fields.quantityStock"
        ></b-input>
      </b-col>

      
      <b-col cols="12" md="6" class="mt-3">
        <label>Cod. Interno</label>
        <b-input
          v-mask="['##########']"
          v-model="fields.codInterno"
          @blur="validCod()"
        ></b-input>
      </b-col>

      <b-col cols="12" md="6" class="mt-4">
        <label>Desconto à vista (%)</label>
        <b-input
        placeholder="%"
          v-model="fields.discont"
          v-mask="['##']"
        ></b-input>
      </b-col>
    
      <b-col cols="12" md="6" class="mt-4">
        <label>Entrega 24hrs</label>
        <b-form-checkbox
          switch
          v-model="fields.withdrawalInOneDay"
        >
        </b-form-checkbox>
      </b-col>

      <b-col cols="12" class="mt-4">
        <b-button @click="save()" variant="success" block>
          Salvar
        </b-button>
      </b-col>
    </b-row>
    </b-modal>
</template>
<script>
import { mapActions } from 'vuex';
import makeToast from '@/mixins/makeToast';
import InputMoney from '@/components/Inputs/InputMoney.vue'

export default {
  name: 'SelectedProductsModal',
  emits:['validCodeModal', 'saveProductModal', 'setCodeInternoModal'],
  mixins: [makeToast],

  components: { InputMoney },
  
  data() {
    return {
      loading: false,
      open: false,
      product: '',
      customPriceModal: null,
      shopkeeperId: null,
      fields: {
        productId: null,
        priceSalesFormat1: null,
        priceSalesFormat2: 0,
        quantityStock: null,
        codInterno: null,
        discont: null, 
        withdrawalInOneDay: false
      }
    };
  },

  methods: {
    ...mapActions('shopkeeper', [
        'validarCodInternoLojista'
    ]),

    toggleOpen({ product = [], shopkeeperId = null }) {
      this.open = !this.open;
      this.product = product;
      this.shopkeeperId = shopkeeperId;
      Object.assign(this.fields, {
        productId: this.product.id, 
        priceSalesFormat1: this.product.priceSalesFormat1, 
        priceSalesFormat2: this.product.priceSalesFormat2,
        quantityStock: this.product.quantityStock,
        codInterno: this.product.codInterno,
        discont:this.product.discont,
        withdrawalInOneDay: this.product.withdrawalInOneDay
      });
    },

    linkFotos(origem) {
      if (origem === 'Belenus') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } 
      return process.env.VUE_APP_FOTOS_URL;
    },

    save() {
      this.$emit('saveProduct', this.fields);
      this.open = !this.open;
    },

    validCod(){
      if (!this.fields.codInterno) return;

      const data = {
        cod: this.fields.codInterno,
        lojista_id: this.shopkeeperId,
      };

      this.loading = true;
      this.$store.dispatch('startLoader');
      this.validarCodInternoLojista(data)
        .then((response) => {
          if (response.data.data.cod === true) {
            this.fields.codInterno = null;
            this.makeToast(
              'Oopss',
              'Esse código interno já está sendo usado!',
              'danger'
            );
          } else {
            this.makeToast('Sucesso', 'código interno disponível!', 'success');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
    .title {
    background-color: yellow;
    padding: 11px;
    border-radius: 10px;
    font-size: 17.5px;
    line-height: 25pt;
  }
  .imgWidth {
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
